module.exports = __webpack_public_path__ + "img/menu.d69e40d0.svg";